import androidx.compose.runtime.*
import components.Footer
import components.Header
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.dom.Main
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.events.EventListener
import pages.*
import shared.content.LegalPagesContent
import shared.content.ReaptiveHomeContent
import styles.GlobalStyles
import theme.ReaptiveTheme
import theme.rememberThemeState

fun main() {
    // Clear server-rendered SEO content before Compose mounts — it's only for crawlers
    document.getElementById("root")?.innerHTML = ""

    renderComposable("root") {
        Style(GlobalStyles)

        var path by remember { mutableStateOf(window.location.pathname) }
        val isDark = rememberThemeState()

        // Reveal page once Compose has rendered (prevents FOUC from server-rendered HTML)
        LaunchedEffect(Unit) {
            document.getElementById("root")?.classList?.add("ready")
        }

        // Listen for browser back/forward
        DisposableEffect(Unit) {
            val listener = EventListener {
                path = window.location.pathname
            }
            window.addEventListener("popstate", listener)
            onDispose { window.removeEventListener("popstate", listener) }
        }

        val navigate: (String) -> Unit = { newPath ->
            if (newPath != path) {
                window.history.pushState(null, "", newPath)
                path = newPath
                window.scrollTo(0.0, 0.0)
            } else {
                window.scrollTo(js("({top: 0, behavior: 'smooth'})"))
            }
        }

        // Update page title and meta description on client-side navigation
        LaunchedEffect(path) {
            val seo = when (path.trimEnd('/').ifEmpty { "/" }) {
                "/" -> ReaptiveHomeContent.pageSeo
                "/privacy-policy" -> LegalPagesContent.privacyPage.pageSeo
                "/terms" -> LegalPagesContent.termsPage.pageSeo
                else -> LegalPagesContent.notFound
            }
            document.title = seo.title
            document.querySelector("meta[name='description']")?.setAttribute("content", seo.description)
        }

        ReaptiveTheme(isDark.value) {
            Header(
                isDark = isDark.value,
                onThemeToggle = { isDark.value = !isDark.value },
                onNavigate = navigate
            )

            Main {
                when (path.trimEnd('/').ifEmpty { "/" }) {
                    "/" -> HomePage()
                    "/privacy-policy" -> PrivacyPage()
                    "/terms" -> TermsPage()
                    else -> NotFoundPage(onNavigate = navigate)
                }
            }

            Footer(onNavigate = navigate)
        }
    }
}
